import { Box, Link, Text } from '@rbilabs/universal-components';

import Picture from 'components/picture';

import theme from '../theme';

export const ImageContainer = Box.withConfig({
  width: 'full',
  justifyContent: 'center',
  alignItems: 'center',
  paddingY: '$6',
});

export const Image = Picture.withConfig({
  width: '5/6',
  borderRadius: Styles.borderRadius,
});

export const ImageCaption = Text.withConfig({
  paddingTop: '$4',
  textAlign: theme.imageWidgetCaptionAlign,
});

export const ImageCaptionLink = Link.withConfig({
  color: Styles.color.primary,
  marginRight: '$2',
  fontSize: 'sm',
});
